import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import getCurrentUid from '../utilities/getCurrentUid'
import Item from '../utilities/Data/Item'
import Colour from '../utilities/Data/Colour'
import maybe from '../utilities/maybe'

const setItemOwn = async ({ own, item }) => {
	try {
		const { itemKey, colourName } = item
		const uid = getCurrentUid()
		const itemOwnerDocRef = firestore.collection('items').doc(itemKey).collection('owners').doc(uid)

		// own
		if (own) {
			const ownerDocSnap = await itemOwnerDocRef.get()
			const isCreate = !ownerDocSnap.exists
			return await itemOwnerDocRef.set({
				uid,
				itemKey,
				colourNames: { [Colour.canonicalName(colourName)]: true },
				...maybe({ createdTimestamp: firebase.firestore.FieldValue.serverTimestamp() }, isCreate),
				modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp()
			}, { merge: true })
		}

		// un-own
		if (!colourName || Item.isSameColourName(colourName, Item.allColours)) {
			// all colours (delete from item page) - just remove the whole owner doc
			return await itemOwnerDocRef.delete()
		}

		// delete the specified colourName
		const operation = itemOwnerDocRef.set({
			colourNames: { [Colour.canonicalName(colourName)]: firebase.firestore.FieldValue.delete() },
			modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp()
		}, { merge: true })

		// prepare cleanup that we do not want to wait for
		// delete owner doc if no colourNames
		operation.then(async () => {
			const ownerDocSnap = await itemOwnerDocRef.get()
			if (Object.keys(ownerDocSnap.data().colourNames).length === 0) {
				itemOwnerDocRef.delete()
			}
		})

		return await operation
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, exception)
	}
}
export default setItemOwn



// WEBPACK FOOTER //
// ./src/dataservices/setItemOwn.js